<form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
  <div class="row m-t-10">
    <div class="col-sm-12">
      <span class="form-control-label required">Old password</span>
      <input
        pInputText
        class="form-control"
        type="password"
        formControlName="oldPassword"
        placeholder="Old password"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <span class="form-control-label required">New password</span>
      <input
        pInputText
        class="form-control"
        type="password"
        formControlName="password"
        placeholder="New password"
        tooltipPosition="top"
        tooltipEvent="focus"
        pTooltip="Please include at least:
        - one small letter
        - one capital letter
        - one number
        - 7 characters"
      />
    </div>
  </div>

  <div class="row m-t-10">
    <div class="col-sm-12">
      <span class="form-control-label required">Confirm password</span>
      <input
        pInputText
        class="form-control"
        type="password"
        formControlName="passwordConfirm"
        placeholder="Confirm password"
      />
    </div>
  </div>

  <div class="row centered m-t-20">
    <div class="col-sm-12">
      <button
        pButton
        size="large"
        severity="success"
        type="submit"
        [disabled]="loading"
      >
        @if (loading) {
          <i class="pi pi-spinner"></i>
        }
        Change password
      </button>
    </div>
  </div>
</form>
